import { useEffect, useState } from 'react'
import styled from 'styled-components'
import useAtomWithRef from '../../../utils/useAtomWithRef'
import { videoElementAtom } from './atoms'

/*============================= Types ========================================*/

type TimelineHoverProps = {
  timelineRef: React.RefObject<HTMLDivElement>
}

/*======================== React component ===================================*/

const TimelineHover = ({ timelineRef }: TimelineHoverProps): JSX.Element => {
  const [videoElementRef, videoElement] = useAtomWithRef(videoElementAtom)

  const [showHoverSeconds, setShowHoverSeconds] = useState(false)
  const [hoverPosition, setHoverPosition] = useState(0)

  useEffect(() => {
    if (!videoElement) {
      return
    }

    // Add listener to enable clicking to skip to a certain time in the video.
    timelineRef.current?.addEventListener('click', (e) => {
      const rect = timelineRef.current!.getBoundingClientRect()
      const clickPercentage = (e.x - rect.x) / rect.width

      const newElapsedTime = clickPercentage * videoElementRef.current!.duration

      videoElement.currentTime = newElapsedTime
    })

    timelineRef?.current?.addEventListener('mouseenter', () => {
      setShowHoverSeconds(true)
    })

    timelineRef.current?.addEventListener('mousemove', (e) => {
      const rect = timelineRef.current!.getBoundingClientRect()
      const clickPercentage = (e.x - rect.x) / rect.width
      setHoverPosition(clickPercentage)
    })

    timelineRef.current?.addEventListener('mouseleave', () => {
      setShowHoverSeconds(false)
    })
  }, [timelineRef, videoElement])

  const hoverSeconds = (videoElement?.duration || 0) * hoverPosition

  // Create a string with the time in the format '00:00:00' if the minutes are more than 60.
  // Otherwise, just use the minutes and seconds.
  let hoverSecondsString = new Date(hoverSeconds * 1000).toISOString().substr(11, 8)
  if (hoverSecondsString.substr(0, 2) == '00') {
    hoverSecondsString = hoverSecondsString.substr(3)
  }

  return (
    <Wrapper>
      <style>
        {`.timeline-hover-seconds {
            position:absolute;
            left: ${hoverPosition * 100}%;
            transform: translateX(-50%);
            top: -30px;
            color: white;
            opacity: ${showHoverSeconds ? 1 : 0};
            user-select: none;
            pointer-events: none;
        }
            `}
      </style>
      <div className="timeline-hover-seconds">{hoverSecondsString}</div>
      <style>
        {`.hover-seeker {
            position:absolute;
            left: ${hoverPosition * 100}%;
            top: 2px;
            transform: translate(-50%, -50%);
            background: white;
            opacity: ${showHoverSeconds ? 1 : 0};
            user-select: none;
            width: 4px;
            height: 12px;
            border-radius: 100px;
            pointer-events: none;
            z-index: 100;
        }
            `}
      </style>
      <div className="hover-seeker" />
    </Wrapper>
  )
}

export default TimelineHover

const Wrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  pointer-events: none;
`
